import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Reassurance() {
  return <section className="w-full bg-secondary px-5 py-12 sm:py-20" data-id="element-201" data-mp="5crwny8ybo3f">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto grid max-w-4xl items-center gap-8 rounded-2xl border border-primary/20 bg-card p-6 sm:p-10 md:grid-cols-2" data-id="element-202" data-mp="jbrcqhieeunz">
        <div className="overflow-hidden rounded-xl" data-id="element-203" data-mp="o9jfk6kl016y">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/a1dfd1c1-58c9-4773-abe9-d4f215f9ba3f.jpg" alt="Children's hands testing a popsicle stick catapult on a wooden table" loading="lazy" className="block aspect-[3/2] w-full object-cover" data-id="element-204" data-mp="12yz2tckwlohw" />
        </div>
        <div className="text-center md:text-left" data-id="element-205" data-mp="171vfkmnriqdx">
          <h2 className="font-display text-2xl font-bold leading-tight text-foreground sm:text-3xl" data-id="element-206" data-mp="16yzguw43bxof">
            Zacznijcie od jednej karty. Jeszcze dziś.
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground/75 sm:text-base" data-id="element-207" data-mp="2qs3368tw020">
            Po zakupie wybierz projekt, wydrukuj kartę i zamień zwykłe popołudnie w coś, co Twoje
            dziecko z dumą pokaże całej rodzinie.
          </p>
          <div className="mt-7" data-id="element-208" data-mp="gqaycygjjgww">
            <CTAButton label="CHCĘ CAŁĄ PRACOWNIĘ ZA 73 ZŁ" data-id="element-209" data-mp="gp9ogxb9h0gr" />
          </div>
        </div>
      </motion.div>
    </section>;
}